export const supportedLngs = ["ro", "en", "el", "sk", "fr-CH"];
export const DEFAULT_LANGUAGE = "en";

export const ni18nConfig = {
  supportedLngs,
  ns: ["common"],
};
